var React = require('react');

function File (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z","key":0}),React.createElement("polyline",{"points":"13 2 13 9 20 9","key":1})]);
}

File.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","className":"feather feather-file"};

module.exports = File;

File.default = File;
